import React from "react";
import AppRoutes from "./routes";
import { LanguageProvider } from "./contexts/LanguageContext";

const layoutStyle = {
  width: "100%", 
  height: "100%", 
  margin: 0, 
  padding: 0, 
  boxSizing: "border-box", 
};


function App() {
  return (
    <LanguageProvider>
      <div style={layoutStyle}>
        <AppRoutes />
      </div>
    </LanguageProvider>
  );
}

export default App;
